<div class="bubble-popover-shell">
	<div class="bubble-popover">
		<span class="bubble-popover__arrow" aria-hidden="true"></span>

		<div class="bubble-popover__content">
			@if (listed) {
				@if (options.length) {
					<ion-list lines="none">
						@for (option of options; track option.id) {
							<ion-item
								[id]="option.id"
								[button]="options.length > 0"
								[attr.data-test]="'popover-' + option.title.toLowerCase()"
								(click)="executeAction(option.action!)"
							>
								{{ option.title | translate }}
							</ion-item>
						}
					</ion-list>
				}
				<div class="popover-message-container">
					<p class="popover-message">{{ message | translate }}</p>
				</div>
			} @else {
				<div
					class="clickable"
					[attr.data-test]="'popover-' + options[0].title.toLowerCase()"
					(click)="executeAction(options[0].action!)"
				>
					{{ options[0].title | translate }}
				</div>
				<div class="popover-message-container">
					<p class="popover-message">{{ message | translate }}</p>
				</div>
			}
		</div>
	</div>
</div>
